import React, { useState } from "react";
import { startRegistration } from "@simplewebauthn/browser";
import api from "../services/api";

const BiometricSetup = () => {
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [message, setMessage] = useState("");

  const handleEnroll = async () => {
    try {
      setStatus("loading");
      setMessage("");

      // 1. Get registration options from backend
      const optionsRes = await api.post("/webauthn/register/options");
      const options = optionsRes.data.options;

      // 2. Trigger the native fingerprint/Face ID prompt
      const registrationResponse = await startRegistration({ optionsJSON: options });

      // 3. Send the result back to backend for verification
      const deviceName = window.navigator.userAgent.includes("Windows")
        ? "Windows device"
        : window.navigator.userAgent.includes("Mac")
        ? "Mac device"
        : "This device";

      await api.post("/webauthn/register/verify", {
        ...registrationResponse,
        deviceName,
      });

      setStatus("success");
      setMessage("Biometric login set up successfully for this device.");
    } catch (err) {
      setStatus("error");
      setMessage(
        err.response?.data?.message ||
          err.message ||
          "Setup failed. Make sure your device has fingerprint/Face ID enabled."
      );
    }
  };

  return (
    <div style={styles.card}>
      <h3 style={styles.title}>Biometric Login</h3>
      <p style={styles.subtitle}>
        Set up fingerprint or Face ID login for this device.
      </p>

      <button
        style={styles.button}
        onClick={handleEnroll}
        disabled={status === "loading"}
      >
        {status === "loading" ? "Waiting for fingerprint..." : "Set Up Biometric Login"}
      </button>

      {message && (
        <p style={{ ...styles.message, color: status === "error" ? "#b91c1c" : "#166534" }}>
          {message}
        </p>
      )}
    </div>
  );
};

const styles = {
  card: {
    background: "#fff",
    borderRadius: "16px",
    padding: "24px",
    boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)",
    maxWidth: "420px",
  },
  title: { margin: "0 0 6px 0", fontSize: "18px", color: "#1e293b" },
  subtitle: { margin: "0 0 16px 0", fontSize: "14px", color: "#64748b" },
  button: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "none",
    background: "#2563eb",
    color: "#fff",
    fontWeight: "600",
    cursor: "pointer",
  },
  message: { marginTop: "14px", fontSize: "13px", fontWeight: "600" },
};

export default BiometricSetup;